import styled from 'styled-components';
import globalStyles from './global-styles';
import spacer from './spacer';

export default styled.input.attrs(({ $dutchTel = false }) => {
  if ($dutchTel) {
    return {
      title: 'Voer een geldig Nederlands telefoonnummer in',
      pattern: '(^\\+[0-9]{2}|^\\+[0-9]{2}\\(0\\)|^\\(\\+[0-9]{2}\\)\\(0\\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\\-\\s]{10}$)',
    };
  }
  return {};
})`
  ${globalStyles}
  ${({ $noSpacer }) => !$noSpacer && spacer}
`;
